export const resumeData = {
  summary: `Interligar a IA com a linguagem, cultura e tecnologia para ajudar empresas globais a expandirem-se com confiança e impacto. Com mais de 15 anos em localização, trago uma combinação de gestão de programas, perícia em marketing e inovação em IA — sempre com foco no capacitar de equipas e mentoria da próxima geração de líderes.`,
  
  experience: [
    {
      id: 0,
      company: 'Transição de Carreira',
      role: 'Aberta a Novas Oportunidades',
      location: 'Área da Baía de São Francisco',
      period: 'Jul 2025 - Presente',
      type: 'Pausa na Carreira',
      description: 'Após o anúncio do encerramento do MIIS até Junho de 2027, estou a procurar ativamente novas oportunidades em Estratégia de Localização por IA, Gestão de Programas e Educação.',
      achievements: [
        'Aproveitamento de 15+ anos de experiência em localização e gestão de programas',
        'Aberta a funções de liderança em IA/Localização, estratégia GTM e educação',
        'Disponível para cargos a tempo inteiro, consultoria ou funções de aconselhamento'
      ],
      linkedInPost: 'https://www.linkedin.com/posts/maramartinspt_middlebury-to-close-miis-by-june-2027-the-share-7367252461322977280-JJ6m'
    },
    {
      id: 1,
      company: 'Middlebury Institute of International Studies',
      role: 'Professora Convidada',
      location: 'Monterey, Califórnia',
      period: 'Jul 2023 - Jul 2025',
      type: 'Tempo Inteiro',
      description: 'Leccionação de cursos de pós-graduação no Programa de Gestão de Tradução e Localização e defesa da adopção de IA Responsável na Localização.',
      achievements: [
        'Conceção e lançamento da primeira série de eventos de IA do instituto "IA na Localização" através da colaboração com líderes da indústria (GitLab, Block, Coupa, Smartling)',
        'Conceção e ensino de cursos de pós-graduação sobre Gestão de Programas Globais, adopção de IA em Localização e Automação',
        'Mentoria de 90+ estudantes em três coortes, guiando equipas na construção de fluxos de trabalho E2E prontos para o mercado e GLM'
      ]
    },
    {
      id: 2,
      company: 'Block',
      role: 'Líder de Gestão de Programas - Localização',
      location: 'Estados Unidos',
      period: 'Nov 2021 - Nov 2022',
      type: 'Tempo Inteiro',
      description: 'Liderança de uma equipa de Gestores de Programas responsáveis pelo apoio à expansão global do ecossistema de produtos da Square.',
      achievements: [
        'Liderança de uma equipa de Gestores de Programas (5 reportes directos e expansão para 15)',
        'Apoio a fornecedores na entrega de campanhas de marketing multilingues e lançamentos de produtos em 10+ mercados',
        'Parceria inter-funcional com equipas de Marca, Marketing de Produto, Legal e Regionais',
        'Introdução de fluxos de trabalho escaláveis e infraestruturas de qualidade para acelerar a prontidão de mercado'
      ]
    },
    {
      id: 3,
      company: 'LinkedIn',
      role: 'Gestora Sénior de Marketing - Localização',
      location: 'Sunnyvale, Califórnia',
      period: 'Mar 2020 - Out 2021',
      type: 'Tempo Inteiro',
      description: 'Gestão de reportes directos e supervisão dos processos diários da equipa e excelência operacional.',
      achievements: [
        'Gestão da compensação anual e discussões de carreira de reportes directos',
        'Coaching e mentoria de equipas para trabalhar em iniciativas de alto impacto',
        'Coordenação global entre equipas gerindo uma equipa diversificada em múltiplos fusos horários',
        'Apoio ao crescimento da estratégia internacional do LinkedIn durante a COVID, incluindo "Stories" e internacionalização do LinkedIn Learning em 17 mercados'
      ]
    },
    {
      id: 4,
      company: 'Microsoft',
      role: 'Gestora Sénior de Marcom Global - Localização e Operações',
      location: 'Área de Seattle',
      period: 'Jun 2016 - Mar 2020',
      type: 'Tempo Inteiro',
      description: 'Direção da execução do programa global de localização, estratégia e inovação do MSCOM e Store.',
      achievements: [
        'Gestão de talento de equipa multi-fornecedor (equipa de mais de 15 pessoas) e oferta de produtos globais para 200 mercados (100 línguas)',
        'Responsável pela gestão eficiente do orçamento e alocação de prioridades principais',
        'Garantia de experiências de cliente impecáveis e impacto de negócio em todo o mundo'
      ]
    }
  ],
  
  education: [
    {
      degree: 'Licenciatura em Tradução e Interpretação (Línguas Estrangeiras Aplicadas)',
      institution: 'Escola Superior de Tecnologia e Gestão (Instituto Politécnico de Leiria)',
      location: 'Leiria, Portugal',
      year: '2001 - 2007',
      details: 'Foco em Tradução e Interpretação'
    }
  ],
  
  skills: {
    gtm: [
      'Estratégia e Execução de Go-to-Market (GTM) Regional',
      'Gestão de Lançamento Global de Produtos e Funcionalidades',
      'Prontidão de Mercado e Capacitação de Lançamento',
      'Operações de Marketing e Execução de Lançamento'
    ],
    program: [
      'Liderança de Programas Cross-Funcionais',
      'Gestão de Programas e Projetos End-to-End',
      'Excelência Operacional e Optimização de Fluxos de Trabalho',
      'Gestão de Stakeholders em Organizações Matriciais'
    ],
    localization: [
      'Estratégia de Localização Global (45+ Mercados)',
      'Gestão de Mudança e Capacitação de Adopção',
      'Localização em Escala',
      'Gestão de Fornecedores'
    ],
    technology: [
      'Smartling',
      'Figma',
      'Integração de CMS e TMS',
      'Fluxos de Trabalho Ágeis',
      'Python (Aprendizagem)',
      'GitHub'
    ]
  },
  
  languages: [
    { language: 'Português', level: 'Nativo', flag: '🇵🇹' },
    { language: 'Inglês', level: 'Fluente', flag: '🇺🇸' },
    { language: 'Espanhol', level: 'Profissional', flag: '🇪🇸' }
  ],
  
  links: {
    linkedin: 'https://www.linkedin.com/in/maramartinspt',
    github: 'https://github.com/marapt',
    email: 'marapt@gmail.com',
    phone: '+16506669468'
  }
};
